import * as actions from "../action.constants";

// The taskId is otherwise only ever handed to us once, in the clone-sensors
// POST response body. Mirroring it (plus targetMac) to localStorage means a
// page reload or closed tab doesn't lose track of an in-flight clone — the
// global CloneSensorsWatcher sees taskId already set on load and resumes
// polling, so the completion toast still fires even though the tab was
// reloaded mid-clone.
const STORAGE_KEY = "zeus:cloneSensorsOperation";
const EMPTY_PROGRESS = {current: 0, total: 0};
const EMPTY_STATE = {taskId: null, targetMac: null, progress: EMPTY_PROGRESS};

const readPersisted = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const {taskId, targetMac} = JSON.parse(raw);
    // A partial entry (e.g. targetMac lost to an earlier bug, manual edit,
    // or interrupted write) can never be resumed — CloneSensorsWatcher
    // requires both to poll. Treat it as if nothing were persisted and
    // clear it, rather than leaving a dead entry that wedges the feature
    // on every future load.
    if (!taskId || !targetMac) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    // Progress is live/transient — always start at 0/0 on load and let the
    // next poll refresh it, rather than persisting (and trusting) a
    // possibly-stale snapshot.
    return {taskId, targetMac, progress: EMPTY_PROGRESS};
  } catch {
    return null;
  }
};

const persist = ({taskId, targetMac}) => {
  try {
    if (taskId) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({taskId, targetMac}));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // localStorage unavailable (private browsing, quota, etc.) — Redux
    // state still works for the current tab, it just won't survive a
    // reload.
  }
};

const initialState = readPersisted() || EMPTY_STATE;

const CloneProfile = (state = initialState, action) => {
  switch (action.type) {
    case actions.CLONE_STARTED: {
      const next = {
        taskId: action.payload.taskId,
        targetMac: action.payload.targetMac,
        progress: EMPTY_PROGRESS,
      };
      persist(next);
      return next;
    }
    case actions.CLONE_PROGRESS_UPDATED:
      return {
        ...state,
        progress: {current: action.payload.current, total: action.payload.total},
      };
    case actions.CLONE_SENSORS_RESET:
      persist(EMPTY_STATE);
      return EMPTY_STATE;
    default:
      return state;
  }
};

export default CloneProfile;
